
export interface StateItem<T> {
    item:T,
    createdAt:Date,
    expireAt:Date,
}

export function buildStateItem<T>(item:T,validityMin:number = 5):StateItem<T> {
    const createdAt = new Date()
    const expireAt =  new Date()
    expireAt.setMinutes(expireAt.getMinutes() + validityMin)
    return {
        item,
        createdAt, 
        expireAt
    }
}